import { bffApi } from "../../../../services/bff/bffApi";
import { BaseService } from "../../../../global/classes";
import {ChargebackFilter, ChargebackItem, DisputesRequestDto, PatchDisputeStatusDto} from "../types";

export default class ChargebackService extends BaseService {
 getChargebacks = async (
  page: number,
  pageSize: number,
  filter?: ChargebackFilter,
  email?: string | null
) => {
  const merchant = this.selectedCompany
    ? this.selectedCompany.merchantId
    : filter?.merchant && filter.merchant.length > 0
    ? filter.merchant
    : undefined;

  try {
    const params: any = {
      currentPage: page,
      pageSize,
      paged: true,
      ...filter,
      merchant,
      ...(email ? { email } : {}),
    };

    const response = await bffApi.get(
      `/api/gcb/v1/chargeback`,
      {
        params,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

  createChargeback = async (payload: DisputesRequestDto): Promise<void> => {
    try {
      // Criar FormData
      const formData = new FormData();

      // Adicionar todos os campos (exceto ChargebackPdf)
      formData.append('MerchantId', payload.MerchantId);
      formData.append('PaymentDate', payload.PaymentDate);
      formData.append('Nsu', payload.Nsu);
      formData.append('CaptureChannel', payload.CaptureChannel);
      formData.append('Parcels', payload.Parcels.toString());
      formData.append('PaymentValue', payload.PaymentValue.toString());
      formData.append('LiquidValue', payload.LiquidValue.toString());
      formData.append('Authorization', payload.Authorization);
      formData.append('ChargebackValue', payload.ChargebackValue.toString());
      formData.append('DisputeReason', payload.DisputeReason);
      formData.append('DateLimit', payload.DateLimit);
      formData.append('DisputeStatus', payload.DisputeStatus.toString());
      formData.append('Brand', payload.Brand);
      formData.append('Acquirer', payload.Acquirer.toString());

      if (payload.ProductName) {
        formData.append('ProductName', payload.ProductName);
      }
      if (payload.CreatedBy) {
        formData.append('CreatedBy', payload.CreatedBy);
      }
      if (payload.LastUpdatedBy) {
        formData.append('LastUpdatedBy', payload.LastUpdatedBy);
      }

      // Adicionar arquivo PDF se existir
      if (payload.ChargebackPdf) {
        formData.append('ChargebackPdf', payload.ChargebackPdf);
      }

      await bffApi.post(
        `/api/gcb/v1/chargeback`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    } catch (error) {
      throw error;
    }
  };

  updateChargeback = async (
    chargebackId: string,
    payload: PatchDisputeStatusDto
  ): Promise<void> => {
    try {
      // Criar FormData
      const formData = new FormData();

      formData.append('ChargebackId', chargebackId);
      formData.append('MerchantId', payload.MerchantId);
      formData.append('Nsu', payload.Nsu);
      formData.append('Authorization', payload.Authorization);
      formData.append('OldDisputeStatus', payload.OldDisputeStatus.toString());
      formData.append('NewDisputeStatus', payload.NewDisputeStatus.toString());
      formData.append('CreatedBy', payload.CreatedBy);

      if (payload.DisputeReason !== undefined) {
        formData.append('DisputeReason', payload.DisputeReason);
      }

      // Adicionar arquivo PDF se existir
      if (payload.ChargebackPdf) {
        formData.append('ChargebackPdf', payload.ChargebackPdf);
      }

      await bffApi.patch(
        `/api/gcb/v1/chargeback/update-status`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    } catch (error) {
      throw error;
    }
  };

  downloadPdf = async (record: ChargebackItem) => {
    try {
      const response =  await bffApi.get(`/api/gcb/v1/chargeback/download`, {
        params: record,
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  updateRefundStatus = async (data: any) => {
    console.log(data);

    const body = data.map((modifiedItem: {id: string, values: {refundCompleted: boolean; merchantId: string; refundValue: number; refundMethod: string}}) => {
      return {
        id: parseInt(modifiedItem.id),
        merchantId: modifiedItem.values.merchantId,
        refundValue: modifiedItem.values.refundValue,
        refundMethod: modifiedItem.values.refundMethod
      }
    });

    try {
      const response =  await bffApi.patch(`/api/gcb/v1/billingbymerchant/chargeback-refund-by-id`,
        body);

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  downloadChargebackPanelXls = async (filter?: ChargebackFilter, email?: string | null) => {
  try {
    const params: any = {
      ...filter,
      ...(email ? { email } : {}),
    };

    const response = await bffApi.get(
      `/api/gcb/v1/chargeback/chargebackPanel-xls`,
      {
        params,
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
}
